import { convertStrToFloat } from '../../util/utils';

export const sortByScore = (results, selectedFilters) => {
    /* 'Gain weight', 'Lose weight', etc values refer to filter TAG values;
     which are the values stored in elasticsearch */
    results = results.slice();

    if (selectedFilters.includes('Gain weight') || selectedFilters.includes('Lose weight')) {
        return sortByWeight(results);
    } else if (selectedFilters.includes('Healthy eating')) {
        return sortByHealthyEating(results);
    }
    return sortByOverall(results);
}

const sortByOverall = (results) => {
    return results.sort((resultA, resultB) => {
        return sortByDefault(resultA, resultB);
    });
}

const sortByWeight = (results) => {
    return results.sort((resultA, resultB) => {
        let scoreA = convertStrToFloat(resultA['weightVariation'], 2);
        let scoreB = convertStrToFloat(resultB['weightVariation'], 2);

        return customSort(resultA, scoreA, resultB, scoreB);
    });
}

const sortByHealthyEating = (results) => {
    return results.sort((resultA, resultB) => {
        let scoreA = calcAvgHealthScore(resultA);
        let scoreB = calcAvgHealthScore(resultB)

        return customSort(resultA, scoreA, resultB, scoreB);
    });
}

const customSort = (resultA, scoreA, resultB, scoreB) => {
    if (scoreA > scoreB) {
        return -1;
    } else if (scoreA < scoreB) {
        return 1;
    }

    return sortByDefault(resultA, resultB);
}

const sortByDefault = (resultA, resultB) => {
    const scoreA = convertStrToFloat(resultA['overallRating'], 2);
    const scoreB = convertStrToFloat(resultB['overallRating'], 2);

    if (scoreA > scoreB) {
        return -1;
    } else if (scoreA < scoreB) {
        return 1;
    }

    return 0;
}

export const calcAvgHealthScore = (result) => {
    const scores = parseScores(result);

    const averageScore = scores.reduce(getSum, 0) / scores.length;
    return +averageScore.toFixed(2);
}

const parseScores = (result) => {
    const scorenames = ['wholeBodyHealth', 'nutritionQuality', 'healthyEatingHabits'];
    
    let scores = [];
    scorenames.forEach(scorename => {
        if (result[scorename]) {
            const value = convertStrToFloat(result[scorename], 2);
            scores.push(value);
        }
    });

    return scores;
}

const getSum = (total, num) => {
    return total + num;
}